export default __webpack_public_path__ + "static/media/elipse.b8800bd4.svg";